import config from '@/config'
import MKKVStorage from '@/lib/zustand-storage'
import type { FirebaseApp, FirebaseOptions } from 'firebase/app'
import { getApp, getApps, initializeApp } from 'firebase/app'
import type { Auth } from 'firebase/auth'
import type { ReactNativeAsyncStorage } from 'firebase/auth'
import { getAuth, getReactNativePersistence, initializeAuth } from 'firebase/auth'
import { Platform } from 'react-native'

const firebaseConfig: FirebaseOptions = {
	apiKey: config.FIREBASE_API_KEY,
	authDomain: config.FIREBASE_AUTH_DOMAIN,
	projectId: config.FIREBASE_PROJECT_ID,
	storageBucket: config.FIREBASE_STORAGE_BUCKET,
	messagingSenderId: config.FIREBASE_MESSAGING_SENDER_ID,
	appId: config.FIREBASE_APP_ID,
}

const createFirebaseApp = () => {
	let firebaseApp: FirebaseApp
	let firebaseAuth: Auth

	if (getApps().length === 0) {
		firebaseApp = initializeApp(firebaseConfig, 'wally-patients')
		firebaseAuth =
			Platform.OS === 'web'
				? getAuth(firebaseApp)
				: initializeAuth(firebaseApp, {
						persistence: getReactNativePersistence(
							MKKVStorage as ReactNativeAsyncStorage
						),
				  })

		firebaseAuth.tenantId = config.FIREBASE_TENANT_ID
	} else {
		firebaseApp = getApp()
		firebaseAuth = getAuth(firebaseApp)
	}

	return { firebaseApp, firebaseAuth }
}

const { firebaseApp, firebaseAuth } = createFirebaseApp()

export { firebaseApp, firebaseAuth }
